export type AssignmentPrincipalType = (typeof AssignmentPrincipalType)[keyof typeof AssignmentPrincipalType];

export const AssignmentPrincipalType = {
    UserId: 'UserId',
    ClientId: 'ClientId',
    GroupId: 'GroupId',
    UserEmail: 'UserEmail',
    TenantId: 'TenantId',
} as const;
